import mixin from '../../mixins/mixin';
import analyticsService from '../../services/analytics';

export default {
  data() {
    return {
      loading: false,
      smallLoading: false,
      user: {},
      analyseData: {
        address: '',
        rooms: '',
        email: ''
      }
    };
  },
  mixins: [ mixin ],
  async mounted() {
    let input = document.getElementById('analyse-address');
    let autocomplete = new google.maps.places.Autocomplete(input);

    google.maps.event.addListener(autocomplete, 'place_changed',  () => {
      let place = autocomplete.getPlace();
    });
  },
  components: {
    VLoading : require('components/loading/loading.vue')
  },
  methods: {
    async generateAnalyses() {
      this.analyseData.email = this.account.email;
      this.openModal("#generate-analyses-results-modal");
    },
    getAnalyseData() {
      this.analyseData.address = $("#analyse-address").val();
      this.smallLoading = true;
      analyticsService.getAnalyseResults(this.analyseData, this);
    },
    closeAnalyseModal(modalName) {
      this.closeModal(modalName);
      this.analyseData = {
        'address': '',
        'rooms' : '',
        'email': this.account.email
      };
      $('.pac-target-input').val('');
    }
  },
  computed: {
    account: function () {
      return this.$store.state.account;
    }
  }
};



// WEBPACK FOOTER //
// ./src/app/components/generate-analyses/index.js